module.exports = __webpack_public_path__ + "img/desire_001.499519d.webp";